/**
 * Admin Configuration Store Module
 * Manages system-wide configuration settings accessible only to SuperAdmins
 * Settings are persisted to localStorage for consistency across sessions
 */

const STORAGE_KEY = 'adminConfig';

// Load configuration from localStorage or use defaults
const loadConfigFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    console.error('Error loading admin config from localStorage:', error);
  }
  return null;
};

// Default configuration values
const defaultConfig = {
  superAdminBypassOverlaysEnabled: true
};

const storedConfig = loadConfigFromStorage();
const initialConfig = storedConfig ? { ...defaultConfig, ...storedConfig } : defaultConfig;

export default {
  namespaced: true,
  state: {
    config: initialConfig
  },
  getters: {
    superAdminBypassOverlaysEnabled: state => state.config.superAdminBypassOverlaysEnabled,
    allConfig: state => state.config
  },
  mutations: {
    setSuperAdminBypassOverlaysEnabled(state, value) {
      state.config.superAdminBypassOverlaysEnabled = value;
      saveConfigToStorage(state.config);
    },
    setConfig(state, config) {
      state.config = { ...state.config, ...config };
      saveConfigToStorage(state.config);
    },
    resetConfig(state) {
      state.config = { ...defaultConfig };
      saveConfigToStorage(state.config);
    }
  },
  actions: {
    toggleSuperAdminBypassOverlaysEnabled({ commit, state }) {
      commit('setSuperAdminBypassOverlaysEnabled', !state.config.superAdminBypassOverlaysEnabled);
    },
    updateConfig({ commit }, config) {
      commit('setConfig', config);
    },
    resetToDefaults({ commit }) {
      commit('resetConfig');
    }
  }
};

// Helper function to save configuration to localStorage
function saveConfigToStorage(config) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  } catch (error) {
    console.error('Error saving admin config to localStorage:', error);
  }
}
